import get from 'lodash/get';
import { BASE_ASSET_CATEGORY } from 'utils/constants/assetText';
import { getItemOrDefaultToValue, getItemOrNull } from 'utils/details';
import isEmpty from 'lodash/isEmpty';

export const transformCreateAssetData = (asset, id) => {
  const ids = asset?.departments &&
    asset?.departments.length > 0 && {
      departmentIds: getItemOrDefaultToValue(
        asset,
        'departments',
        undefined,
      )?.map(m => m.id),
    };
  switch (asset.category) {
    case BASE_ASSET_CATEGORY.VEHICLE.id:
    case BASE_ASSET_CATEGORY.CANINE.id:
    case BASE_ASSET_CATEGORY.FIREARM.id:
    case BASE_ASSET_CATEGORY.VEHICLE_OFF_ROAD.id:
    case BASE_ASSET_CATEGORY.VEHICLE_VAN.id:
    case BASE_ASSET_CATEGORY.VEHICLE_BUS.id:
    case BASE_ASSET_CATEGORY.OTHER.id:
      return {
        archived: get(asset, 'archived', false),
        assetId: get(asset, 'assetId', null),
        name: get(asset, 'assetName', '-'),
        licenseRequired: get(asset, 'licenseRequired', false),
        description: get(asset, 'description', ''),
        businessClient: {
          id: get(asset, 'site.businessClientId'),
          businessClientName: get(asset, 'site.businessClientName'),
          businessClientId: get(asset, 'site.businessClientReadableId'),
        },
        assignedSite: {
          id: get(asset, 'site.id'),
          siteId: get(asset, 'site.siteId'),
          siteName: get(asset, 'site.siteName'),
          inductionRequired: get(asset, 'site.inductionRequired', false),
        },
        imageBase64: asset.image ? get(asset, 'image') : undefined,
        surfaces: asset.surfaces ? get(asset, 'surfaces') : [],
        type: {
          id: id,
        }, // only add department array if any id is selected
        ...(ids && { departmentIds: ids.departmentIds }),
      };
    case BASE_ASSET_CATEGORY.ROBOT.id:
    case BASE_ASSET_CATEGORY.SENSOR.id:
      return {
        archived: get(asset, 'archived', false),
        assetId: get(asset, 'assetId', null),
        name: get(asset, 'assetName', '-'),
        licenseRequired: get(asset, 'licenseRequired', false),
        description: get(asset, 'description', ''),
        password: get(asset, 'password', null),
        businessClient: {
          id: get(asset, 'site.businessClientId'),
          businessClientName: get(asset, 'site.businessClientName'),
          businessClientId: get(asset, 'site.businessClientReadableId'),
        },
        assignedSite: {
          id: get(asset, 'site.id'),
          siteId: get(asset, 'site.siteId'),
          siteName: get(asset, 'site.siteName'),
          inductionRequired: get(asset, 'site.inductionRequired', false),
        },
        imageBase64: asset.image ? get(asset, 'image') : undefined,
        surfaces: asset.surfaces ? get(asset, 'surfaces') : [],
        type: {
          id: id,
        }, // only add department array if any id is selected
        ...(ids && { departmentIds: ids.departmentIds }),
        rules: asset.rules?.map(val => ({
          name: val['name'].value,
          eventCategory: val['eventCategory'].value,
          duration: parseInt(val['duration'].value, 10),
          eventType: val['eventType'].value,
          key: val['key'].value,
          operator: val['operator'].value,
          value: val['value'].value,
        })),
      };
    case BASE_ASSET_CATEGORY.PHONE.id:
      return {
        archived: get(asset, 'archived'),
        assetId: get(asset, 'assetId', null),
        name: get(asset, 'assetName', '-'),
        description: get(asset, 'description', ''),
        businessClient: {
          id: get(asset, 'site.businessClientId'),
          businessClientName: get(asset, 'site.businessClientName'),
          businessClientId: get(asset, 'site.businessClientReadableId'),
        },
        assignedSite: {
          id: get(asset, 'site.id'),
          siteId: get(asset, 'site.siteId'),
          siteName: get(asset, 'site.siteName'),
          inductionRequired: get(asset, 'site.inductionRequired', false),
        },
        imageBase64: asset.image ? get(asset, 'image') : undefined,
        surfaces: asset.surfaces ? get(asset, 'surfaces') : [],
        type: {
          id: id,
        },
        phoneNumber: {
          country: get(asset, 'country', '-'),
          number: get(asset, 'phone', '-'),
        },
        //lockedToSite: get(asset, 'lockedToSite'),
        ...(ids && { departmentIds: ids.departmentIds }),
      };
    default:
      return {
        archived: get(asset, 'archived', false),
        assetId: get(asset, 'assetId', null),
        name: get(asset, 'assetName', '-'),
        description: get(asset, 'description', ''),
        businessClient: {
          id: get(asset, 'site.businessClientId'),
          businessClientName: get(asset, 'site.businessClientName'),
          businessClientId: get(asset, 'site.businessClientReadableId'),
        },
        assignedSite: {
          id: get(asset, 'site.id'),
          siteId: get(asset, 'site.siteId'),
          siteName: get(asset, 'site.siteName'),
          inductionRequired: get(asset, 'site.inductionRequired', false),
        },
        imageBase64: asset.image ? get(asset, 'image') : undefined,
        surfaces: asset.surfaces ? get(asset, 'surfaces') : [],
        type: {
          id: id,
        },
        ...(ids && { departmentIds: ids.departmentIds }),
      };
  }
};
export const transformAssetDataWithType = asset => {
  const ids = asset?.departments &&
    asset?.departments.length > 0 && {
      departmentIds: getItemOrDefaultToValue(
        asset,
        'departments',
        undefined,
      )?.map(m => m.id),
    };

  switch (asset.category) {
    case BASE_ASSET_CATEGORY.VEHICLE.id:
    case BASE_ASSET_CATEGORY.CANINE.id:
    case BASE_ASSET_CATEGORY.FIREARM.id:
    case BASE_ASSET_CATEGORY.VEHICLE_OFF_ROAD.id:
    case BASE_ASSET_CATEGORY.VEHICLE_VAN.id:
    case BASE_ASSET_CATEGORY.VEHICLE_BUS.id:
    case BASE_ASSET_CATEGORY.OTHER.id:
      return {
        archived: get(asset, 'archived', false),
        assetId: get(asset, 'assetId', null),
        name: get(asset, 'assetName', '-'),
        licenseRequired: get(asset, 'licenseRequired', false),
        description: get(asset, 'description', ''),
        businessClient: {
          id: get(asset, 'site.businessClientId'),
          businessClientName: get(asset, 'site.businessClientName'),
          businessClientId: get(asset, 'site.businessClientReadableId'),
        },
        assignedSite: {
          id: get(asset, 'site.id'),
          siteId: get(asset, 'site.siteId'),
          siteName: get(asset, 'site.siteName'),
          inductionRequired: get(asset, 'site.inductionRequired', false),
        },
        imageBase64: asset.image ? get(asset, 'image') : undefined,
        surfaces: asset.surfaces ? get(asset, 'surfaces') : [],
        type: {
          assetTypeId: getItemOrNull(asset, 'assetTypeId'),
          category: get(asset, 'category'),
          name: get(asset, 'type'), //type
          qualificationRequired: get(asset, 'qualificationRequired', false),
          handoverRequired: get(asset, 'handoverRequired', false),
          archived: false,
        },
        ...(ids && { departmentIds: ids.departmentIds }),
      };
    case BASE_ASSET_CATEGORY.ROBOT.id:
    case BASE_ASSET_CATEGORY.SENSOR.id:
      return {
        archived: get(asset, 'archived', false),
        assetId: get(asset, 'assetId', null),
        name: get(asset, 'assetName', '-'),
        licenseRequired: get(asset, 'licenseRequired', false),
        description: get(asset, 'description', ''),
        password: get(asset, 'password', null),
        businessClient: {
          id: get(asset, 'site.businessClientId'),
          businessClientName: get(asset, 'site.businessClientName'),
          businessClientId: get(asset, 'site.businessClientReadableId'),
        },
        assignedSite: {
          id: get(asset, 'site.id'),
          siteId: get(asset, 'site.siteId'),
          siteName: get(asset, 'site.siteName'),
          inductionRequired: get(asset, 'site.inductionRequired', false),
        },
        imageBase64: asset.image ? get(asset, 'image') : undefined,
        surfaces: asset.surfaces ? get(asset, 'surfaces') : [],
        type: {
          assetTypeId: getItemOrNull(asset, 'assetTypeId'),
          category: get(asset, 'category'),
          name: get(asset, 'type'), //type
          qualificationRequired: get(asset, 'qualificationRequired', false),
          handoverRequired: get(asset, 'handoverRequired', false),
          archived: false,
        },
        rules: asset.rules?.map(val => ({
          name: val['name'].value,
          eventCategory: val['eventCategory'].value,
          duration: parseInt(val['duration'].value, 10),
          eventType: val['eventType'].value,
          key: val['key'].value,
          operator: val['operator'].value,
          value: val['value'].value,
        })),
        ...(ids && { departmentIds: ids.departmentIds }),
      };
    case BASE_ASSET_CATEGORY.PHONE.id:
      return {
        archived: get(asset, 'archived'),
        assetId: get(asset, 'assetId', null),
        name: get(asset, 'assetName', '-'),
        description: get(asset, 'description', ''),
        businessClient: {
          id: get(asset, 'site.businessClientId'),
          businessClientName: get(asset, 'site.businessClientName'),
          businessClientId: get(asset, 'site.businessClientReadableId'),
        },
        assignedSite: {
          id: get(asset, 'site.id'),
          siteId: get(asset, 'site.siteId'),
          siteName: get(asset, 'site.siteName'),
          inductionRequired: get(asset, 'site.inductionRequired', false),
        },
        imageBase64: asset.image ? get(asset, 'image') : undefined,
        surfaces: asset.surfaces ? get(asset, 'surfaces') : [],
        type: {
          assetTypeId: getItemOrNull(asset, 'assetTypeId'),
          category: get(asset, 'category'),
          name: get(asset, 'type'), //type
          qualificationRequired: get(asset, 'qualificationRequired', false),
          handoverRequired: get(asset, 'handoverRequired', false),
          archived: false,
        },
        phoneNumber: {
          country: get(asset, 'country', '-'),
          number: get(asset, 'phone', '-'),
        },
        //lockedToSite: get(asset, 'lockedToSite'),
        ...(ids && { departmentIds: ids.departmentIds }),
      };
    default:
      return {
        archived: get(asset, 'archived', false),
        assetId: get(asset, 'assetId', null),
        name: get(asset, 'assetName', '-'),
        description: get(asset, 'description', ''),
        businessClient: {
          id: get(asset, 'site.businessClientId'),
          businessClientName: get(asset, 'site.businessClientName'),
          businessClientId: get(asset, 'site.businessClientReadableId'),
        },
        assignedSite: {
          id: get(asset, 'site.id'),
          siteId: get(asset, 'site.siteId'),
          siteName: get(asset, 'site.siteName'),
          inductionRequired: get(asset, 'site.inductionRequired', false),
        },
        imageBase64: asset.image ? get(asset, 'image') : undefined,
        surfaces: asset.surfaces ? get(asset, 'surfaces') : [],
        type: {
          assetTypeId: getItemOrNull(asset, 'assetTypeId'),
          category: get(asset, 'category'),
          name: get(asset, 'type'), //type
          qualificationRequired: get(asset, 'qualificationRequired', false),
          handoverRequired: get(asset, 'handoverRequired', false),
          archived: false,
        },
        ...(ids && { departmentIds: ids.departmentIds }),
      };
  }
};
export const transformAssetTypeData = assetType => {
  const ids = assetType?.departments &&
    !isEmpty(assetType?.departments) && {
      departmentIds: getItemOrDefaultToValue(
        assetType,
        'departments',
        undefined,
      )?.map(m => m.id),
    };

  return {
    archived: get(assetType, 'archived', false),
    assetList: get(assetType, 'assetList', {}),
    assetTypeId: getItemOrNull(assetType, 'assetTypeId'),
    category: get(
      assetType,
      assetType.category?.id ? 'category.id' : 'category',
      '',
    ),
    description: get(assetType, 'description', ''),
    handoverRequired: get(assetType, 'handoverRequired', false),
    id: get(assetType, 'id', undefined),
    name: get(assetType, 'name', ''),
    qualificationRequired: get(assetType, 'qualificationRequired', false),
    ...(ids && { departmentIds: ids.departmentIds }),
  };
};
